export default "__VITE_ASSET__c5f262ac__"